/**
 * PainPause theme event publisher V1
 * VERSION: V1
 * DATE: 2026-10-09
 * Sends the same events with gtag('event', name, params) on storefront pages.
 * No console output. The only global is window.PP_ANALYTICS, set by the snippet.
 */
(function () {
  "use strict";
  var VERSION = "V1";
  var VERSION_DATE = "2026-10-09";

  try {
    var cfg = window.PP_ANALYTICS || {};
    var queue = [];
    var ready = false;
    var attempts = 0;
    var scrollMarks = {};
    var videoMarks = {};
    var faqSent = {};

    function sha1Hex(input) {
      var msg = unescape(encodeURIComponent(String(input == null ? "" : input)));
      var ml = msg.length;
      var words = [];
      var i;
      for (i = 0; i < ml; i += 1) words[i >> 2] |= msg.charCodeAt(i) << (24 - (i % 4) * 8);
      words[ml >> 2] |= 0x80 << (24 - (ml % 4) * 8);
      words[(((ml + 8) >> 6) + 1) * 16 - 1] = ml * 8;
      var h0 = 0x67452301;
      var h1 = 0xefcdab89;
      var h2 = 0x98badcfe;
      var h3 = 0x10325476;
      var h4 = 0xc3d2e1f0;
      for (i = 0; i < words.length; i += 16) {
        var w = new Array(80);
        var t;
        for (t = 0; t < 16; t += 1) w[t] = words[i + t] | 0;
        for (t = 16; t < 80; t += 1) {
          var n = w[t - 3] ^ w[t - 8] ^ w[t - 14] ^ w[t - 16];
          w[t] = (n << 1) | (n >>> 31);
        }
        var a = h0;
        var b = h1;
        var c = h2;
        var d = h3;
        var e = h4;
        for (t = 0; t < 80; t += 1) {
          var f;
          var k;
          if (t < 20) {
            f = (b & c) | (~b & d);
            k = 0x5a827999;
          } else if (t < 40) {
            f = b ^ c ^ d;
            k = 0x6ed9eba1;
          } else if (t < 60) {
            f = (b & c) | (b & d) | (c & d);
            k = 0x8f1bbcdc;
          } else {
            f = b ^ c ^ d;
            k = 0xca62c1d6;
          }
          var temp = (((a << 5) | (a >>> 27)) + f + e + k + w[t]) | 0;
          e = d;
          d = c;
          c = (b << 30) | (b >>> 2);
          b = a;
          a = temp;
        }
        h0 = (h0 + a) | 0;
        h1 = (h1 + b) | 0;
        h2 = (h2 + c) | 0;
        h3 = (h3 + d) | 0;
        h4 = (h4 + e) | 0;
      }
      function hex(n) {
        var s = (n >>> 0).toString(16);
        return "00000000".slice(s.length) + s;
      }
      return hex(h0) + hex(h1) + hex(h2) + hex(h3) + hex(h4);
    }

    function neutralId(value) {
      return sha1Hex(value).slice(0, 8);
    }

    function clip(value, max) {
      var text = String(value == null ? "" : value).replace(/\s+/g, " ").trim();
      if (text.length > max) text = text.slice(0, max);
      return text;
    }

    function sensitive(text) {
      return /pain|symptom|condition|treatment|flare|sciatica|arthritis|opioid|surger|injection|migraine|chronic|acute|tendon|nerve|musculoskelet|injur|disease|illness|medication|\bdrug\b|mechanism/i.test(text);
    }

    function safeLabel(text) {
      var label = clip(text, 60).toLowerCase();
      if (!label) return "";
      if (sensitive(label)) return neutralId(label);
      return label;
    }

    function catalogEntry(handle) {
      if (!handle || !cfg.catalog) return null;
      return cfg.catalog[String(handle).toLowerCase()] || null;
    }

    function pathHandle(pathname) {
      var parts = String(pathname || "").split("/").filter(Boolean);
      if (parts.length >= 2 && parts[0] === "pages") return parts[1].toLowerCase();
      return "";
    }

    var ALLOWED_QUERY = { utm_source: 1, utm_medium: 1, utm_campaign: 1, utm_term: 1, utm_content: 1, gclid: 1 };

    function allowedSearch(search) {
      var params;
      try {
        params = new URLSearchParams(search || "");
      } catch (err) {
        return "";
      }
      var kept = new URLSearchParams();
      params.forEach(function (value, key) {
        if (key === "q" || !ALLOWED_QUERY[key]) return;
        kept.append(key, clip(value, 100));
      });
      var query = kept.toString();
      return query ? "?" + query : "";
    }

    function sanitizedPath(pathname) {
      var path = pathname || "/";
      var handle = pathHandle(path);
      var entry = catalogEntry(handle);
      if (entry && entry.id) return "/pages/education/" + entry.id;
      if (handle && sensitive(handle)) return "/pages/education/" + neutralId(handle);
      return path;
    }

    function destination(href) {
      try {
        var url = new URL(href, window.location.origin);
        return sanitizedPath(url.pathname);
      } catch (err) {
        return "";
      }
    }

    function currentLocation() {
      return sanitizedPath(window.location.pathname) + allowedSearch(window.location.search);
    }

    function currentReferrer() {
      if (!document.referrer) return "";
      try {
        var url = new URL(document.referrer);
        return url.origin + sanitizedPath(url.pathname) + allowedSearch(url.search);
      } catch (err) {
        return "";
      }
    }

    function viewportBucket() {
      var width = window.innerWidth || 0;
      if (width < 768) return "mobile";
      if (width < 1200) return "tablet";
      return "desktop";
    }

    function analyticsAllowed() {
      try {
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if (api && typeof api.analyticsProcessingAllowed === "function") return api.analyticsProcessingAllowed() === true;
      } catch (err) {}
      return false;
    }

    function publish(name, data) {
      var payload = data || {};
      payload.v = VERSION;
      payload.page_location = currentLocation();
      payload.page_referrer = currentReferrer();
      if (!ready || typeof window.gtag !== "function" || !analyticsAllowed()) {
        queue.push([name, payload]);
        return;
      }
      try {
        window.gtag("event", name, payload);
      } catch (err) {}
    }

    function flush() {
      if (typeof window.gtag !== "function" || !analyticsAllowed()) return;
      ready = true;
      var pending = queue.slice();
      queue = [];
      pending.forEach(function (item) {
        publish(item[0], item[1]);
      });
    }

    function waitForGtag() {
      if (typeof window.gtag === "function" && analyticsAllowed()) {
        flush();
        return;
      }
      attempts += 1;
      if (attempts > 50) return;
      window.setTimeout(waitForGtag, 100);
    }

    function ctaLocation(el) {
      if (el.closest(".hero, .hero-block")) return "hero";
      if (el.closest("header, .header")) return "header";
      if (el.closest("footer, .footer")) return "footer";
      if (el.closest(".page-banner")) return "banner";
      if (el.closest(".page-intro, .page-overview")) return "page_intro";
      if (el.closest("article, .ed-card, .education-card, .fits-in__card, .mechanism__card")) return "card";
      return "body";
    }

    function navArea(el) {
      var nav = el.closest("nav");
      if (el.closest(".page-overview__nav")) return "breadcrumb";
      if (el.closest("footer, .footer")) return "footer";
      if (nav && nav.classList.contains("is-open")) return "mobile_menu";
      var toggle = document.querySelector("[data-menu-toggle]");
      if (toggle && toggle.getAttribute("aria-expanded") === "true" && el.closest(".header__nav, #HeaderNav")) return "mobile_menu";
      if (el.closest("header, .header")) return "header";
      return "header";
    }

    function onClick(event) {
      var el = event.target && event.target.closest ? event.target.closest("a, button") : null;
      if (!el) return;
      if (el.matches("[data-ed-filter], [data-tab]")) {
        var raw = el.getAttribute("data-ed-filter") || el.getAttribute("data-tab") || "";
        var filterId = raw === "all" || raw === "featured" ? raw : neutralId(raw);
        var surface = el.hasAttribute("data-ed-filter") ? "education" : "tabs";
        publish("filter_select", {
          filter_id: clip(filterId, 100),
          filter_surface: surface,
          page_type: cfg.page_type || ""
        });
        return;
      }
      if (el.matches("a.header__nav-link, .footer a, footer a, .page-overview__nav a")) {
        var label = safeLabel(el.textContent);
        publish("nav_click", {
          nav_area: navArea(el),
          link_label: label,
          destination: destination(el.getAttribute("href") || "")
        });
        return;
      }
      if (!el.matches("a.btn, button.btn, button[class*='btn']")) return;
      var ctaLabel = safeLabel(el.textContent);
      var data = {
        cta_label: ctaLabel,
        cta_location: ctaLocation(el),
        cta_destination: destination(el.getAttribute("href") || ""),
        page_type: cfg.page_type || ""
      };
      publish(ctaLabel === "try today" ? "try_today_click" : "cta_click", data);
    }

    function onScroll() {
      var doc = document.documentElement;
      var height = (doc.scrollHeight || 0) - (window.innerHeight || 0);
      var percent = height <= 0 ? 100 : Math.min(100, Math.round((window.scrollY / height) * 100));
      [25, 50, 75, 90, 100].forEach(function (mark) {
        if (percent >= mark && !scrollMarks[mark]) {
          scrollMarks[mark] = true;
          publish("scroll_depth", {
            percent: mark,
            page_type: cfg.page_type || "",
            content_id: cfg.content_id || ""
          });
        }
      });
    }

    function bindVideo(video) {
      if (!video || video.getAttribute("data-pp-bound") === "1") return;
      video.setAttribute("data-pp-bound", "1");
      var id = "home_player";
      video.addEventListener("play", function () {
        if (videoMarks.start) return;
        videoMarks.start = true;
        publish("video_start", { video_id: id, page_type: cfg.page_type || "" });
      });
      video.addEventListener("timeupdate", function () {
        if (!video.duration || !isFinite(video.duration)) return;
        var pct = Math.floor((video.currentTime / video.duration) * 100);
        [25, 50, 75].forEach(function (mark) {
          if (pct >= mark && !videoMarks[mark]) {
            videoMarks[mark] = true;
            publish("video_progress", { video_id: id, percent: mark, page_type: cfg.page_type || "" });
          }
        });
      });
      video.addEventListener("ended", function () {
        if (videoMarks.done) return;
        videoMarks.done = true;
        publish("video_complete", { video_id: id, page_type: cfg.page_type || "" });
      });
    }

    function onFaqToggle(event) {
      var details = event.target;
      if (!details || details.tagName !== "DETAILS" || !details.open) return;
      if (!details.matches("details.accordion, details.ed-accordion, details[data-accordion], details[data-ed-accordion]")) return;
      var question = details.querySelector(".accordion__question, .ed-accordion__question");
      var text = question ? question.textContent : "";
      if (!text) return;
      var qid = neutralId(clip(text, 500).toLowerCase());
      if (faqSent[qid]) return;
      faqSent[qid] = true;
      publish("faq_open", {
        question_id: qid,
        page_type: cfg.page_type || "",
        content_id: cfg.content_id || ""
      });
    }

    function onSubmit(event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;
      var formId = "other";
      if (form.classList.contains("contact-form") || (form.getAttribute("action") || "").indexOf("contact") !== -1) formId = "contact";
      else if (form.classList.contains("newsletter") || form.hasAttribute("data-newsletter")) formId = "newsletter";
      else return;
      publish("form_submit", { form_id: formId, page_type: cfg.page_type || "" });
    }

    publish("page_context", {
      page_type: cfg.page_type || "",
      page_group: cfg.page_group || "",
      content_id: cfg.content_id || "",
      content_group_id: cfg.content_group_id || "",
      viewport_bucket: viewportBucket()
    });

    if (cfg.search_performed) {
      var count = Number(cfg.search_result_count);
      if (!isFinite(count) || count < 0) count = 0;
      publish("site_search", {
        result_count: count,
        has_results: count > 0 ? 1 : 0,
        page_type: "search"
      });
    }

    document.addEventListener("click", onClick, true);
    document.addEventListener("toggle", onFaqToggle, true);
    document.addEventListener("submit", onSubmit, true);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    document.querySelectorAll("[data-mechanism-video-player]").forEach(bindVideo);

    var vitals = { lcp: 0, cls: 0, inp: 0 };
    var vitalsSent = false;
    function sendVitals() {
      if (vitalsSent) return;
      vitalsSent = true;
      ["lcp", "cls", "inp"].forEach(function (metric) {
        if (!vitals[metric]) return;
        publish("web_vital", {
          metric: metric,
          metric_value: Math.round(vitals[metric] * 1000) / 1000,
          page_type: cfg.page_type || ""
        });
      });
    }
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        var last = entries[entries.length - 1];
        if (last) vitals.lcp = last.startTime;
      }).observe({ type: "largest-contentful-paint", buffered: true });
    } catch (err) {}
    try {
      var cls = 0;
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (!entry.hadRecentInput) cls += entry.value;
        });
        vitals.cls = cls;
      }).observe({ type: "layout-shift", buffered: true });
    } catch (err) {}
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          var value = entry.duration || 0;
          if (value > vitals.inp) vitals.inp = value;
        });
      }).observe({ type: "event", buffered: true, durationThreshold: 40 });
    } catch (err) {}
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") sendVitals();
    });
    window.addEventListener("pagehide", sendVitals);

    document.addEventListener("visitorConsentCollected", function () {
      if (analyticsAllowed()) flush();
    });
    waitForGtag();
    void VERSION_DATE;
  } catch (err) {}
})();
